<template>
  <div>
    <v-alert v-if="readonly" dense outlined type="info" class="mb-4">
      Portföy issue satırından gelindiği için operasyon önerilen policy
      eşleşmesine göre seçili gelir. Manuel değişiklik scope girişinden yapılır.
    </v-alert>

    <v-row dense>
      <v-col
        v-for="operation in operations"
        :key="operation.type"
        cols="12"
        md="6"
      >
        <v-card
          outlined
          class="operation-card h-100"
          :class="{ 'operation-card--active': operation.type === value }"
          @click="selectOperation(operation.type)"
        >
          <v-card-title class="py-3 d-flex align-center justify-space-between">
            <span>{{ operation.label || operation.type }}</span>
            <v-chip
              v-if="operation.type === recommendedOperationType"
              x-small
              outlined
              color="primary"
            >
              Önerilen
            </v-chip>
          </v-card-title>
          <v-card-text>
            <div class="text-body-2 mb-2">
              {{ operation.description || "-" }}
            </div>
            <div class="text-caption text--secondary">
              {{ operation.impact || "-" }}
            </div>
            <div class="mt-3">
              <v-chip
                v-for="namespace in operation.namespaces"
                :key="namespace"
                x-small
                outlined
                class="mr-1 mb-1"
              >
                {{ namespace }}
              </v-chip>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "OperationSelect",
  props: {
    value: {
      type: String,
      default: null,
    },
    operations: {
      type: Array,
      default: () => [],
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    recommendedOperationType: {
      type: String,
      default: null,
    },
  },
  methods: {
    selectOperation(operationType) {
      if (this.readonly) {
        return;
      }

      this.$emit("input", operationType);
    },
  },
};
</script>

<style scoped>
.operation-card {
  cursor: pointer;
  transition: border-color 0.16s ease, background-color 0.16s ease;
}

.operation-card--active {
  background: #f4f6ff;
  border-color: #5e6ad2;
}
</style>
